import React, { useEffect, useState } from 'react';
import FormSection from 'components/sales/formSection/formSection';
import localization from 'assets/localization/localization';
import Regex from 'services/utils/regex/Regex';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import TextAreaInput from 'components/sales/Input/textAreaInput/textAreaInput';
import { FormGroup } from 'react-bootstrap';
import TimePicker from 'react-times';
import { DatePickerInput } from 'rc-datepicker';
import 'react-times/css/classic/default.css';
import dateFormatReverse from 'constants/dateformatReverse';
import FileUpload from 'components/sales/fileUpload/fileUpload';

const MomForm = ({
  handleValue,
  meetingId,
  details = null,
  imageUploadUrl,
  videoUploadUrl,
}) => {
  const inputs = {
    meeting_id: '',
    meeting_date: '',
    meeting_time: `${new Date().getHours()}:${new Date().getMinutes()}`,
    organiser_name: '',
    meeting_location: '',
    attendees: [],
    agenda: '',
    description: '',
    status: 1,
    images: {},
    videos: {},
  };
  const [formData, setData] = useState(inputs);
  const [attendees, setAttendees] = useState('');
  const [isFocus, setIsFocus] = useState(true);

  const handleMeetingData = () => {
    if (
      formData.meeting_date !== '' &&
      formData.meeting_time !== '' &&
      formData.organiser_name !== '' &&
      formData.meeting_location !== '' &&
      formData.attendees.length > 0 &&
      formData.description !== ''
    ) {
      /* Set meeting_id from props */
      handleValue({ ...formData, meeting_id: meetingId });
    } else handleValue(null);
  };

  useEffect(() => {
    handleMeetingData();
  }, [formData]);

  useEffect(() => {
    if (details !== null) {
      setData({
        ...formData,
        meeting_date:
          (details?.scheduled_date &&
            dateFormatReverse(details?.scheduled_date)) ||
          new Date(),
        meeting_time:
          details?.scheduled_time && details?.scheduled_time?.slice(0, 5),
      });
    }
  }, [details]);

  function onChange(value) {
    const { hour, minute } = value;
    setData({ ...formData, meeting_time: `${hour}:${minute}` });
  }

  const handleDateHide = () => {
    if (formData.meeting_date) {
      setIsFocus(true);
    } else setIsFocus(false);
  };

  const handleDateChange = (date, dateString) => {
    setData({ ...formData, meeting_date: dateString });
  };

  return (
    <FormSection title={localization.createMom}>
      <FormGroup
        className={`date custom_date_picker ${isFocus ? 'active-date' : ''}`}
      >
        <DatePickerInput
          value={formData.meeting_date}
          onChange={handleDateChange}
          onShow={() => setIsFocus(true)}
          onHide={handleDateHide}
          onClear={() => setIsFocus(false)}
          autoClose
          closeOnClickOutside
          showOnInputClick
          locale="en"
          className="my-custom-datepicker-component"
          required
          displayFormat="DD-MM-YYYY"
          returnFormat="YYYY-MM-DD"
          minDate={new Date(formData.meeting_date)}
          // maxDate={new Date(formData.meeting_date)}
        />
        <label>
          {localization.selectMeetingDate}
          <span className="label-star" style={{ color: 'red' }}>
            {' '}
            *{' '}
          </span>
        </label>
        {!isFocus && (
          <label className="error date_error">{localization.isRequired}</label>
        )}
      </FormGroup>

      <FormGroup>
        <TimePicker
          theme="classic"
          timeFormat="HH:MM"
          timeMode={24}
          time={formData?.meeting_time}
          onTimeChange={onChange}
        />
        <label>{localization?.selectMeetingTime}</label>
        <label className="error date_error">{localization?.isRequired}</label>
      </FormGroup>

      <FormGroup>
        <FileUpload
          id="uploadSitePhotos"
          multiple
          accept="image/*"
          documentUploadUrl={imageUploadUrl}
          onChange={(val) => {
            setData({
              ...formData,
              images: val.toString(),
            });
          }}
        >
          <span className="btn btn-transparent">
            {localization.uploadPhotos}
          </span>
        </FileUpload>
        <label
          className={`error ${
            Object.keys(formData?.images).length === 0 ? 'error-block' : ''
          }`}
        >
          {localization.pleaseUploadPhotos}
        </label>
      </FormGroup>
      <FormGroup>
        <FileUpload
          id="uploadSiteVideos"
          accept="video/*"
          multiple
          documentUploadUrl={videoUploadUrl}
          onChange={(val) => {
            setData({
              ...formData,
              videos: val.toString(),
            });
          }}
        >
          <span className="btn btn-transparent">
            {localization.uploadVideos}
          </span>
        </FileUpload>
        <label
          className={`error ${
            Object.keys(formData?.videos).length === 0 ? 'error-block' : ''
          }`}
        >
          {localization.pleaseUploadVideos}
        </label>
      </FormGroup>

      <ConstantInput
        value={formData?.organiser_name}
        label={localization?.meetingOrganisorName}
        regex={Regex?.text?.test(formData?.organiser_name)}
        errorMsg={localization?.meetingOrganisorRequired}
        type="text"
        required
        isStarRequired={true}
        handleChange={(val) => setData({ ...formData, organiser_name: val })}
      />

      <ConstantInput
        value={formData?.meeting_location}
        label={localization?.meetingLocation}
        regex={Regex?.text?.test(formData.meeting_location)}
        errorMsg={localization?.isRequired}
        type="text"
        required
        isStarRequired={true}
        handleChange={(val) => setData({ ...formData, meeting_location: val })}
      />

      <ConstantInput
        label={localization?.attendeesName}
        regex={Regex?.textWithComma?.test(attendees)}
        errorMsg={localization?.attendeesNameRequired}
        type="text"
        required
        isStarRequired={true}
        fullWidth
        handleChange={(val) => {
          setAttendees(val);
          const match = val.split(', ');
          setData({ ...formData, attendees: match });
        }}
      />
      <ConstantInput
        value={formData?.agenda}
        label={localization?.meetingAgenda}
        regex={Regex?.text?.test(formData.agenda)}
        errorMsg={formData?.agenda ? localization.isRequired : null}
        type="text"
        fullWidth
        handleChange={(val) => setData({ ...formData, agenda: val })}
      />
      <TextAreaInput
        inputValue={formData?.description}
        className={`${
          !formData.description && 'empty'
        } inline-css scrollbar-styling`}
        rows={4}
        type="text"
        required
        isStarRequired={true}
        regex={Regex.alphaNum.test(formData.description)}
        label={localization.meetingDescription}
        errorMsg={
          formData.description === ''
            ? localization?.meetingDescriptionRequired
            : ''
        }
        handleChange={(e) =>
          setData({ ...formData, description: e.target.value })
        }
      />
    </FormSection>
  );
};

MomForm.propTypes = {};

export default MomForm;
